'use client';

import styles from './FormattedQuestionnaires.module.css';
import { type FC } from 'react';
import { FormattedQuestionnairesProps } from './FormattedQuestionnaires.types';

// Component to format questionnaire results in a grid layout
export const FormattedQuestionnaires: FC<FormattedQuestionnairesProps> = ({
  content,
}) => {
  // Handle undefined or null content
  if (!content) {
    return (
      <div className={styles.questionnaire}>
        No questionnaire data to display
      </div>
    );
  }

  // Parse the content to extract questionnaire information
  const parseQuestionnaire = (text: string) => {
    const lines = text.split('\n');
    const items: Array<{ header?: string; text: string; footer?: boolean }> =
      [];
    let currentHeader = '';

    lines.forEach((line) => {
      // Check for headers (lines ending with ':')
      if (line.trim().match(/^[^-*•].+:$/)) {
        currentHeader = line.trim();
        items.push({ header: currentHeader, text: '' });
      } else if (line.trim().match(/^[-*•]/) || line.trim().match(/^\d+\./)) {
        // Check for bullet points
        items.push({ text: line.trim() });
      } else if (
        line.trim().match(/^Total:/) ||
        line.trim().match(/^Summary:/)
      ) {
        // Check for footers (lines that look like totals or summaries)
        items.push({ text: line.trim(), footer: true });
      } else if (line.trim() && items.length > 0) {
        // Append to previous item if not a special line
        const lastItem = items[items.length - 1];
        if (lastItem.text) {
          lastItem.text += ' ' + line.trim();
        } else {
          lastItem.text = line.trim();
        }
      }
    });

    return items;
  };

  const questionnaireItems = parseQuestionnaire(content);

  // Handle click on questionnaire item
  const handleItemClick = (_item: {
    header?: string;
    text: string;
    footer?: boolean;
  }) => {
    // You can add more interaction here if needed
  };

  return (
    <div className={styles.questionnaire}>
      {questionnaireItems.length > 0 ? (
        questionnaireItems.map((item, index) => (
          <div
            key={index}
            className={`${styles.questionnaireItem} ${item.header ? styles.header : ''} ${item.footer ? styles.footer : ''}`}
            onClick={() => handleItemClick(item)}
          >
            {item.header && (
              <div className={styles.questionnaireHeader}>{item.header}</div>
            )}
            <div className={styles.questionnaireText}>{item.text}</div>
          </div>
        ))
      ) : (
        <div className={styles.questionnaireItem}>
          No questionnaire items found
        </div>
      )}
    </div>
  );
};
